<main edsSpacing="xl">
  <div edsSpacing="xl">
    <ng-container brComponent="lead-content"></ng-container>
  </div>

  <div edsGrid>
    <div class="container container--wide">
      <div edsRow>
        <div edsCol>
          <ng-container brComponent="title-content"></ng-container>
        </div>
      </div>
      <div edsRow edsSpacing="xl">
        <div edsCol edsSpacing="xl" [columnNumbers]="{ s: 4, m: 6, l: 7 }">
          <ng-container brComponent="main-content"></ng-container>
        </div>
        <div edsCol [columnNumbers]="{ s: 4, m: 2, l: 3 }">
          <ng-container brComponent="side-content"></ng-container>
        </div>
      </div>
    </div>
  </div>
</main>
